<template lang="pug">
    div
        //- ==================================================查询列表的dialog==================================================
        el-dialog(
            title="场地信息"
            class="el-dialog-custom"
            top="3vh"
            width="95%"
            :visible.sync="visible"
            :close-on-click-modal="false"
            :append-to-body="true"
            @close="closeDialog"
        )
            div(style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;")
                div(style="display: flex; align-items: center; font-weight: bold;")
                    div(style="margin: 0 12px;") 日期：
                    el-date-picker(type="date" v-model="searchData.openDate" value-format="yyyy-MM-dd" placeholder="请选择日期")
                    div(style="margin: 0 12px;") 场地号：
                    el-input(v-model="searchData.itemNumber" style="width: 200px;" maxlength="50" placeholder="请输入场地号")
                    div(style="margin: 0 12px;") 场地属性：
                    el-select(v-model="searchData.type" clearable placeholder="请选择场地属性")
                        el-option(v-for="item in dycSiteAtrrArray" :key="item.code" :label="item.name" :value="item.code")
                    div(style="margin-left: 10px;")
                        el-button(type="primary" @click="pageSizeChange(pageSizeArr[1])") 查 询
                        el-button(@click="searchData_reset") 重 置
                div
                    el-button(type="primary" @click="visible_add = true") 新 增
                    el-button(type="primary" @click="visible_copy = true") 复制并新建
                    el-button(type="danger" :disabled="selectRows.length === 0" @click="selectRows_delete") 删 除
            el-table(ref="placeInfoList_table_ref" :data="placeInfoList" height="600" border size="mini" row-key="id" @selection-change="placeInfoList_selection" @row-click="placeInfoList_rowClick")
                el-table-column(type="selection" header-align="center" align="center" width="50")
                el-table-column(type="index" header-align="center" align="center" label="序号" width="60")
                el-table-column(header-align="center" align="center" label="场地属性")
                    template(slot-scope="scope")
                        font {{ siteAttributesArray.find(ele => ele.code === scope.row.type).name }}
                el-table-column(prop="number" header-align="center" align="center" label="场地号")
                el-table-column(prop="openDate" header-align="center" align="center" label="日期")
                el-table-column(header-align="center" align="center" label="时间段")
                    template(slot-scope="scope")
                        font {{ scope.row.startTime }} - {{ scope.row.endTime }}
                el-table-column(prop="price" header-align="center" align="center" label="场地价格/元/小时")
                    template(slot-scope="scope")
                        font ￥{{ scope.row.price }}
            el-pagination(@size-change="pageSizeChange" @current-change="pageIndexChange" :current-page="searchData.page" :page-sizes="pageSizeArr" :page-size="searchData.rows" :total="placeInfoList_total" layout="total, sizes, prev, pager, next, jumper")
            span.dialog-footer(slot="footer")
                el-button(@click="closeDialog") 返 回

        //- ==================================================添加场地的dialog==================================================
        el-dialog(
            title="新增场地信息"
            class="el-dialog-custom-add"
            top="9vh"
            width="90%"
            :visible.sync="visible_add"
            :close-on-click-modal="false"
            :append-to-body="true"
            :before-close="closeDialog_add"
        )
            div(style="display: flex; justify-content: space-between; margin-bottom: 20px;")
                el-form(ref="placeInfoList_add_form_ref" :inline="true" :model="placeInfoList_add_form" :rules="placeInfoList_add_form_rules" style="font-weight: bold;")
                    el-form-item(label="日期：" prop="openDate" style="margin-left: 12px;")
                        el-date-picker(type="date" v-model="placeInfoList_add_form.openDate" value-format="yyyy-MM-dd" style="width: 150px;" placeholder="请选择日期")
                    el-form-item(label="时间：" prop="startTime" style="margin-left: 12px;")
                        el-time-select(
                            v-model="placeInfoList_add_form.startTime"
                            style="width: 120px;"
                            :picker-options="{ start: '00:00', step: '01:00', end: '23:00', minTime: mintime }"
                            placeholder="开始时间"
                        )
                        span(style="margin: 0 12px;") 至
                    el-form-item(prop="endTime")
                        el-time-select(
                            v-model="placeInfoList_add_form.endTime"
                            style="width: 120px;"
                            :picker-options="{ start: placeInfoList_add_form.startTime, step: '01:00', end: '24:00', minTime: placeInfoList_add_form.startTime }"
                            placeholder="结束时间"
                        )
                    el-form-item(label="场地号：" prop="number" style="margin-left: 12px;")
                        el-input(v-model="placeInfoList_add_form.number" style="width: 150px;" maxlength="50" placeholder="请输入场地号")
                    el-form-item(label="场地属性：" prop="type" style="margin-left: 12px;")
                        el-select(v-model="placeInfoList_add_form.type" style="width: 150px;" clearable placeholder="请选择场地属性")
                            el-option(v-for="item in dycSiteAtrrArray" :key="item.code" :label="item.name" :value="item.code")
                    el-form-item(label="场地价格：" prop="price" style="margin-left: 12px;")
                        el-input(v-model="placeInfoList_add_form.price" style="width: 150px;" maxlength="50" placeholder="请输入场地价格")
                div
                    el-button(type="primary" @click="visible_add_insert") 添 加
                    el-button(type="danger" :disabled="selectRows_add.length === 0" @click="selectRows_add_delete") 删 除
                    el-button(@click="visible_add_reset") 重 置
            el-table(ref="placeInfoList_add_table_ref" :data="placeInfoList_add" height="570" border size="mini" row-key="__privateId__" @selection-change="placeInfoList_add_selection" @row-click="placeInfoList_add_rowClick")
                el-table-column(type="selection" header-align="center" align="center" width="50")
                el-table-column(type="index" header-align="center" align="center" label="序号" width="60")
                el-table-column(header-align="center" align="center" label="场地属性")
                    template(slot-scope="scope")
                        font {{ siteAttributesArray.find(ele => ele.code === scope.row.type).name }}
                el-table-column(prop="number" header-align="center" align="center" label="场地号")
                el-table-column(prop="openDate" header-align="center" align="center" label="日期")
                el-table-column(header-align="center" align="center" label="时间段")
                    template(slot-scope="scope")
                        font {{ scope.row.startTime }} - {{ scope.row.endTime }}
                el-table-column(prop="price" class-name="table-price-td" header-align="center" align="center" label="场地价格/元/小时")
                    template(slot-scope="scope")
                        el-input(v-model="scope.row.price" class="table-price-input" size="mini" style="width: 200px;" clearable maxlength="50" placeholder="请输入场地价格")
            span.dialog-footer(slot="footer")
                el-button(type="primary" :disabled="placeInfoList_add.length === 0 || visible_add_submit_btn_loading" @click="visible_add_submit") 提 交
                el-button(:disabled="selectRows_add.length === 0" @click="visible_add_changePrice_open") 批量修改价格
                el-button(@click="closeDialog_add") 返 回
        //- ==================================================添加场地的dialog-批量修改价格的dialog==================================================
        el-dialog(
            title="批量修改价格"
            class="el-dialog-custom-change-price"
            top="32vh"
            width="30%"
            :visible.sync="visible_add_changePrice"
            :close-on-click-modal="false"
            :append-to-body="true"
            @close="closeDialog_add_changePrice"
        )
            el-form(ref="placeInfoList_add_changePrice_form_ref" inline :model="placeInfoList_add_changePrice_form" :rules="placeInfoList_add_changePrice_form_rules" style="font-weight: bold;")
                el-form-item(label="场地价格（元/小时）：" prop="price")
                    el-input(v-model="placeInfoList_add_changePrice_form.price" maxlength="50" clearable placeholder="请输入场地价格")
            span.dialog-footer(slot="footer")
                el-button(type="primary" @click="visible_add_changePrice_submit") 确 定
                el-button(@click="closeDialog_add_changePrice") 返 回

        //- ==================================================复制并新建的dialog==================================================
        el-dialog(
            title="复制并新建"
            class="el-dialog-custom-add"
            top="9vh"
            width="90%"
            :visible.sync="visible_copy"
            :close-on-click-modal="false"
            :append-to-body="true"
            :before-close="closeDialog_copy"
        )
            div(style="display: flex; justify-content: space-between; margin-bottom: 12px;")
                el-form(ref="placeInfoList_copy_form_ref" :inline="true" :model="placeInfoList_copy_form" :rules="placeInfoList_copy_form_rules" style="font-weight: bold;")
                    el-form-item(label="日期：" prop="openDate" style="margin-left: 12px;")
                        el-date-picker(
                            type="date"
                            v-model="placeInfoList_copy_form.openDate"
                            value-format="yyyy-MM-dd"
                            style="width: 150px;"
                            placeholder="请选择日期"
                            @change="placeInfoList_copy_form.targetDate = [];"
                        )
                    el-form-item(label="场地号：" prop="itemNumber" style="margin-left: 12px;")
                        el-input(v-model="placeInfoList_copy_form.itemNumber" style="width: 150px;" maxlength="50" placeholder="请输入场地号")
                    el-form-item(label="场地属性：" prop="type" style="margin-left: 12px;")
                        el-select(v-model="placeInfoList_copy_form.type" style="width: 150px;" clearable placeholder="请选择场地属性")
                            el-option(v-for="item in dycSiteAtrrArray" :key="item.code" :label="item.name" :value="item.code")
                    el-form-item(label="复制到：" prop="targetDate" style="margin-left: 12px;")
                        el-date-picker(
                            ref="placeInfoList_copy_targetDate_ref"
                            type="dates"
                            v-model="placeInfoList_copy_form.targetDate"
                            value-format="yyyy-MM-dd"
                            style="width: 600px;"
                            placeholder="请选择日期"
                            :picker-options="{ disabledDate (time) { return time.getTime() < Date.parse(placeInfoList_copy_form.openDate); } }"
                        )
                div
                    el-button(type="primary" @click="visible_copy_insert") 添 加
                    el-button(type="danger" :disabled="selectRows_copy.length === 0" @click="selectRows_copy_delete") 删 除
                    el-button(@click="visible_copy_reset") 重 置
            el-table(ref="placeInfoList_copy_table_ref" :data="placeInfoList_copy" height="570" border size="mini" row-key="__privateId__" @selection-change="placeInfoList_copy_selection" @row-click="placeInfoList_copy_rowClick")
                el-table-column(type="selection" header-align="center" align="center" width="50")
                el-table-column(type="index" header-align="center" align="center" label="序号" width="60")
                el-table-column(header-align="center" align="center" label="场地属性")
                    template(slot-scope="scope")
                        font {{ siteAttributesArray.find(ele => ele.code === scope.row.type).name }}
                el-table-column(prop="number" header-align="center" align="center" label="场地号")
                el-table-column(prop="openDate" header-align="center" align="center" label="日期")
                el-table-column(header-align="center" align="center" label="时间段")
                    template(slot-scope="scope")
                        font {{ scope.row.startTime }} - {{ scope.row.endTime }}
                el-table-column(prop="price" class-name="table-price-td" header-align="center" align="center" label="场地价格/元/小时")
                    template(slot-scope="scope")
                        el-input(v-model="scope.row.price" class="table-price-input" size="mini" style="width: 200px;" clearable maxlength="50" placeholder="请输入场地价格")
            span.dialog-footer(slot="footer")
                el-button(type="primary" :disabled="placeInfoList_copy.length === 0 || visible_copy_submit_btn_loading" @click="visible_copy_submit") 提 交
                el-button(:disabled="selectRows_copy.length === 0" @click="visible_copy_changePrice_open") 批量修改价格
                el-button(@click="closeDialog_copy") 返 回
        //- ==================================================复制并新建的dialog-批量修改价格的dialog==================================================
        el-dialog(
            title="批量修改价格"
            class="el-dialog-custom-change-price"
            top="32vh"
            width="30%"
            :visible.sync="visible_copy_changePrice"
            :close-on-click-modal="false"
            :append-to-body="true"
            @close="closeDialog_copy_changePrice"
        )
            el-form(ref="placeInfoList_copy_changePrice_form_ref" inline :model="placeInfoList_copy_changePrice_form" :rules="placeInfoList_copy_changePrice_form_rules" style="font-weight: bold;")
                el-form-item(label="场地价格（元/小时）：" prop="price")
                    el-input(v-model="placeInfoList_copy_changePrice_form.price" maxlength="50" clearable placeholder="请输入场地价格")
            span.dialog-footer(slot="footer")
                el-button(type="primary" @click="visible_copy_changePrice_submit") 确 定
                el-button(@click="closeDialog_copy_changePrice") 返 回
</template>

<script>
// 场地价格正则表达式
// 必须是正数，不能为0，小数位不能超过两位
const placePriceReg = /^(?!0+(\.0{1,2})?$)([1-9]\d*|0)(\.\d{1,2})?$/

export default {
  name: 'PlaceInfo',
    data () {
        return {
            // ==================================================查询列表==================================================
            visible: false,
            placeId: '',
            siteAttributesArray: [],
            dycSiteAtrrArray: [],
            placeInfoList: [],
            pageSizeArr: [10, 20, 30, 50],
            placeInfoList_total: 0,
            searchData: {
                page: 1,
                rows: 10,
                openDate: '',
                itemNumber: '',
                type: ''
            },
            selectRows: [],
            mintime: '',
            // ==================================================新增场地==================================================
            visible_add: false,
            placeInfoList_add_flagNum: 0,
            placeInfoList_add: [],
            placeInfoList_add_form: {
                openDate: null,
                startTime: null,
                endTime: null,
                number: null,
                type: null,
                price: null
            },
            selectRows_add: [],
            visible_add_submit_btn_loading: false,
            placeInfoList_add_form_rules: {
                openDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
                startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
                number: [{ required: true, message: '请输入场地号', trigger: 'blur' }],
                type: [{ required: true, message: '请选择场地属性', trigger: 'change' }],
                price: [{ required: true, message: '请输入场地价格', trigger: 'blur' }, {
                    validator: (rule, value, callback) => {
                        if (Number(value) === 0) {
                            callback(new Error('场地价格不能为零'))
                        } else if (!placePriceReg.test(value)) {
                            callback(new Error('场地价格输入有误'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
            },
            // ==================================================新增场地-批量修改价格的dialog==================================================
            visible_add_changePrice: false,
            placeInfoList_add_changePrice_form: {
                price: null
            },
            placeInfoList_add_changePrice_form_rules: {
                price: [{ required: true, message: '请输入场地价格', trigger: 'blur' }, {
                    validator: (rule, value, callback) => {
                        if (Number(value) === 0) {
                            callback(new Error('场地价格不能为零'))
                        } else if (!placePriceReg.test(value)) {
                            callback(new Error('场地价格输入有误'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }]
            },
            // ==================================================复制并新建==================================================
            visible_copy: false,
            placeInfoList_copy_flagNum: 0,
            placeInfoList_copy: [],
            placeInfoList_copy_form: {
                openDate: null,
                itemNumber: null,
                type: null,
                targetDate: [],
            },
            selectRows_copy: [],
            visible_copy_submit_btn_loading: false,
            placeInfoList_copy_form_rules: {
                openDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
                targetDate: [{ required: true, message: '请选择日期', trigger: 'change' }]
            },
            // ==================================================复制并新建-批量修改价格的dialog==================================================
            visible_copy_changePrice: false,
            placeInfoList_copy_changePrice_form: {
                price: null
            },
            placeInfoList_copy_changePrice_form_rules: {
                price: [{ required: true, message: '请输入场地价格', trigger: 'blur' }, {
                    validator: (rule, value, callback) => {
                        if (Number(value) === 0) {
                            callback(new Error('场地价格不能为零'))
                        } else if (!placePriceReg.test(value)) {
                            callback(new Error('场地价格输入有误'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }]
            }
        }
    },
    methods: {
        // ==================================================查询列表==================================================
        // dialog初始化
        init (placeId, siteAttributesArray) {
            this.visible = true
            this.placeId = placeId
            this.siteAttributesArray = siteAttributesArray
            this.searchData.rows = this.pageSizeArr[1]
            this.startHour()
            this.getPlaceTypeList()
            this.getPlaceInfoList()
        },
        // 获取场地起始时间
        startHour () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/startHour`),
                method: 'get'
            })
            .then(data => {
                const time = data.data * 1 - 1
                if (time < 10) {
                    this.mintime = '0' + time + ':' + '00'
                } else {
                    this.mintime = time + ':' + '00'
                }
            })
        },
        // 获取场地属性列表
        getPlaceTypeList () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/${this.placeId}`),
                method: 'get'
            })
            .then(data => {
                if (data && data.code === 0) {
                    const tempArr = data.data.typeLabels.split('/')
                    this.dycSiteAtrrArray = data.data.type.split(',').map((item, index) => {
                        return {
                            code: item,
                            name: tempArr[index]
                        }
                    })
                }
            })
        },
        // 获取场地列表
        getPlaceInfoList () {
            this.$http({
                url: this.$http.adornUrl('/bp-book-places/queryItemPage'),
                method: 'post',
                data: {
                    placeId: this.placeId,
                    ...this.searchData
                }
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.placeInfoList = data.pageInfo.list.map(item => {
                        if (item.endTime === '23:59') {
                            item.endTime = '24:00'
                        }
                        return item
                    })
                    this.placeInfoList_total = data.pageInfo.total
                } else {
                    this.placeInfoList = []
                    this.placeInfoList_total = 0
                }
            })
        },
        // 重置搜索条件
        searchData_reset () {
            this.searchData = {
                page: 1,
                rows: this.searchData.rows,
                openDate: '',
                itemNumber: '',
                type: ''
            }
            this.getPlaceInfoList()
        },
        // 每页数改变
        pageSizeChange (val) {
            this.searchData.rows = val
            this.searchData.page = 1
            this.getPlaceInfoList()
        },
        // 页码改变
        pageIndexChange (val) {
            this.searchData.page = val
            this.getPlaceInfoList()
        },
        // 点击行勾选
        placeInfoList_rowClick (row) {
            this.$refs.placeInfoList_table_ref.toggleRowSelection(row)
        },
        // 表格勾选
        placeInfoList_selection (val) {
            this.selectRows = val
        },
        // 批量删除
        selectRows_delete () {
            this.$confirm(`是否确认删除选中的 ${this.selectRows.length} 条数据？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                const placeItemIds = this.selectRows.map(item => item.id)
                this.$http({
                    url: this.$http.adornUrl(`/bp-book-places/deleteItems/${this.placeId}`),
                    method: 'post',
                    data: placeItemIds
                })
                .then(data => {
                    if (data && data.code === 0) {
                        this.$message.success('删除成功')
                        this.pageSizeChange(this.pageSizeArr[1])
                    } else {
                        this.$message.error(data.msg || '删除失败，请稍后再试')
                    }
                })
            })
        },
        // 弹窗关闭
        closeDialog () {
            this.searchData = {
                page: 1,
                rows: this.searchData.rows,
                openDate: '',
                itemNumber: '',
                type: ''
            }
            this.visible = false
        },
        // ==================================================新增场地==================================================
        // 添加场地
        visible_add_insert () {
			this.$refs.placeInfoList_add_form_ref.validate(valid => {
				if (valid) {
                    this.placeInfoList_add_flagNum += 1
                    // 把时间范围给拆分成一小时
                    const startTimeNumber = this.placeInfoList_add_form.startTime.split(':')[0]
                    const endTimeNumber = this.placeInfoList_add_form.endTime.split(':')[0]
                    const timeNumber = Number(endTimeNumber) - Number(startTimeNumber)
                    const arr = []
                    for (let i = 0; i < timeNumber; i++) {
                        const { openDate, number, type, price } = this.placeInfoList_add_form
                        const startTime = (Number(startTimeNumber) + i + '').padStart(2, '0') + ':00'
                        const endTime = (Number(startTimeNumber) + i + 1 + '').padStart(2, '0') + ':00'
                        arr.push({
                            __privateId__: `${i}${this.placeInfoList_add_flagNum}`,
                           openDate,
                           number,
                           type,
                           price,
                           startTime,
                           endTime
                        })
                    }
                    this.placeInfoList_add.push(...arr)
                    // this.visible_add_reset()
                    this.$message.success('添加成功')
				}
			})
        },
        // 添加场地-重置
        visible_add_reset () {
            this.$refs.placeInfoList_add_form_ref.fields.forEach(field => {
                field.resetField()
            })
        },
        // 点击行勾选
        placeInfoList_add_rowClick (row, col) {
            // 如果是价格输入框，则不勾选
            if (col.property === 'price') return
            this.$refs.placeInfoList_add_table_ref.toggleRowSelection(row)
        },
        // 表格勾选
        placeInfoList_add_selection (val) {
            this.selectRows_add = val
        },
        // 批量删除
        selectRows_add_delete () {
            this.$confirm(`是否确认删除选中的 ${this.selectRows_add.length} 条数据？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                const placeItemIds = this.selectRows_add.map(item => item.__privateId__)
                const newArr = this.placeInfoList_add.filter(item => !placeItemIds.includes(item.__privateId__))
                this.placeInfoList_add = newArr
                this.$message.success('删除成功')
            })
        },
        // 新增场地-提交
        visible_add_submit () {
            const tableTrDom = this.$refs.placeInfoList_add_table_ref.$el.querySelectorAll('.el-table__row')
            let isValid = true
            for (let i = 0; i < this.placeInfoList_add.length; i++) {
                const price = this.placeInfoList_add[i].price
                if (!price || !placePriceReg.test(price)) {
                    tableTrDom[i].querySelector('.table-price-input input').classList.add('table-td-is-error')
                    isValid = false
                } else {
                    tableTrDom[i].querySelector('.table-price-input input').classList.remove('table-td-is-error')
                }
            }
            if (!isValid) return this.$message.error('请完善场地价格')
            this.$confirm('是否确认提交？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                this.visible_add_submit_btn_loading = true
                for (const item of this.placeInfoList_add) {
                    if (item.endTime === '24:00') {
                        item.endTime = '23:59'
                    }
                }
                this.$http({
                    url: this.$http.adornUrl(`/bp-book-places/saveItems/${this.placeId}`),
                    method: 'post',
                    data: this.placeInfoList_add
                })
                .then(data => {
                    this.visible_add_submit_btn_loading = false
                    if (data && data.code === 0) {
                        this.$message.success('提交成功')
                        this.placeInfoList_add = []
                        this.closeDialog_add()
                        this.pageIndexChange(1)
                    } else {
                        this.$message.error(data.msg || '提交失败，请稍后再试')
                    }
                })
            })
        },
        // 批量修改价格-打开
        visible_add_changePrice_open () {
            this.visible_add_changePrice = true
            this.placeInfoList_add_changePrice_form.price = this.selectRows_add[0].price
        },
        // 批量修改价格-提交
        visible_add_changePrice_submit () {
            this.$refs.placeInfoList_add_changePrice_form_ref.validate(valid => {
                if (valid) {
                    this.selectRows_add.forEach(item => {
                        item.price = this.placeInfoList_add_changePrice_form.price
                    })
                    this.closeDialog_add_changePrice()
                    this.$message.success('批量修改成功')
                    this.$refs.placeInfoList_add_table_ref.clearSelection()
                    this.selectRows_add = []
                }
            })
        },
        // 弹窗关闭
        closeDialog_add (done) {
            if (this.placeInfoList_add.length !== 0) {
                this.$confirm('您有未提交的场地信息，是否确认关闭？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    this.visible_add_reset()
                    this.placeInfoList_add = []
                    this.placeInfoList_add_flagNum = 0
                    this.visible_add = false
                    if (typeof (done) === 'function') done()
                })
            } else {
                this.visible_add_reset()
                this.placeInfoList_add = []
                this.placeInfoList_add_flagNum = 0
                this.visible_add = false
                if (typeof (done) === 'function') done()
            }
        },
        // 批量修改价格-弹窗关闭
        closeDialog_add_changePrice () {
            this.visible_add_changePrice = false
        },
        // ==================================================复制并新建==================================================
        // 添加场地
        visible_copy_insert () {
			this.$refs.placeInfoList_copy_form_ref.validate(valid => {
				if (valid) {
                    this.placeInfoList_copy_flagNum += 1
                    this.$http({
                        url: this.$http.adornUrl('/bp-book-places/queryItemPage'),
                        method: 'post',
                        data: {
                            placeId: this.placeId,
                            openDate: this.placeInfoList_copy_form.openDate,
                            itemNumber: this.placeInfoList_copy_form.itemNumber || null,
                            type: this.placeInfoList_copy_form.type || null
                        }
                    })
                    .then(data => {
                        if (data && data.code === 0) {
                            if (data.pageInfo.list.length === 0) {
                                this.$message.warning(`未查询到 ${this.placeInfoList_copy_form.openDate} 的场地信息`)
                            } else {
                                for (const ele of this.placeInfoList_copy_form.targetDate) {
                                    for (let i = 0; i < data.pageInfo.list.length; i++) {
                                        const item = JSON.parse(JSON.stringify(data.pageInfo.list[i]))
                                        item.openDate = ele
                                        item.__privateId__ = `${ele}${i}${this.placeInfoList_copy_flagNum}`
                                        if (item.endTime === '23:59') {
                                            item.endTime = '24:00'
                                        }
                                        this.placeInfoList_copy.push(item)
                                    }
                                }
                                // this.visible_copy_reset()
                                this.$message.success('添加成功')
                            }
                        }
                    })
				}
			})
        },
        // 添加场地-重置
        visible_copy_reset () {
            this.$refs.placeInfoList_copy_form_ref.fields.forEach(field => {
                field.resetField()
            })
        },
        // 点击行勾选
        placeInfoList_copy_rowClick (row, col) {
            // 如果是价格输入框，则不勾选
            if (col.property === 'price') return
            this.$refs.placeInfoList_copy_table_ref.toggleRowSelection(row)
        },
        // 表格勾选
        placeInfoList_copy_selection (val) {
            this.selectRows_copy = val
        },
        // 批量删除
        selectRows_copy_delete () {
            this.$confirm(`是否确认删除选中的 ${this.selectRows_copy.length} 条数据？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                const placeItemIds = this.selectRows_copy.map(item => item.__privateId__)
                const newArr = this.placeInfoList_copy.filter(item => !placeItemIds.includes(item.__privateId__))
                this.placeInfoList_copy = newArr
                this.$message.success('删除成功')
            })
        },
        // 新增场地-提交
        visible_copy_submit () {
            const tableTrDom = this.$refs.placeInfoList_copy_table_ref.$el.querySelectorAll('.el-table__row')
            let isValid = true
            for (let i = 0; i < this.placeInfoList_copy.length; i++) {
                const price = this.placeInfoList_copy[i].price
                if (!price || !placePriceReg.test(price)) {
                    tableTrDom[i].querySelector('.table-price-input input').classList.add('table-td-is-error')
                    isValid = false
                } else {
                    tableTrDom[i].querySelector('.table-price-input input').classList.remove('table-td-is-error')
                }
            }
            if (!isValid) return this.$message.error('请完善场地价格')
            for (const item of this.placeInfoList_copy) {
                if (item.endTime === '24:00') {
                    item.endTime = '23:59'
                }
            }
            this.$confirm('是否确认提交？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                this.visible_copy_submit_btn_loading = true
                this.$http({
                    url: this.$http.adornUrl(`/bp-book-places/saveItems/${this.placeId}`),
                    method: 'post',
                    data: this.placeInfoList_copy
                })
                .then(data => {
                    this.visible_copy_submit_btn_loading = false
                    if (data && data.code === 0) {
                        this.$message.success('提交成功')
                        this.placeInfoList_copy = []
                        this.closeDialog_copy()
                        this.pageIndexChange(1)
                    } else {
                        this.$message.error(data.msg || '提交失败，请稍后再试')
                    }
                })
            })
        },
        // 批量修改价格-打开
        visible_copy_changePrice_open () {
            this.visible_copy_changePrice = true
            this.placeInfoList_copy_changePrice_form.price = this.selectRows_copy[0].price
        },
        // 批量修改价格-提交
        visible_copy_changePrice_submit () {
            this.$refs.placeInfoList_copy_changePrice_form_ref.validate(valid => {
                if (valid) {
                    this.selectRows_copy.forEach(item => {
                        item.price = this.placeInfoList_copy_changePrice_form.price
                    })
                    this.closeDialog_copy_changePrice()
                    this.$message.success('批量修改成功')
                    this.$refs.placeInfoList_copy_table_ref.clearSelection()
                    this.selectRows_copy = []
                }
            })
        },
        // 弹窗关闭
        closeDialog_copy (done) {
            if (this.placeInfoList_copy.length !== 0) {
                this.$confirm('您有未提交的场地信息，是否确认关闭？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    this.visible_copy_reset()
                    this.placeInfoList_copy = []
                    this.placeInfoList_copy_flagNum = 0
                    this.visible_copy = false
                    if (typeof (done) === 'function') done()
                })
            } else {
                this.visible_copy_reset()
                this.placeInfoList_copy = []
                this.placeInfoList_copy_flagNum = 0
                this.visible_copy = false
                if (typeof (done) === 'function') done()
            }
        },
        // 批量修改价格-弹窗关闭
        closeDialog_copy_changePrice () {
            this.visible_copy_changePrice = false
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog-custom {
    overflow: hidden !important;
}

.el-dialog-custom /deep/ .el-dialog__body {
    height: 75vh;
    overflow: auto;
    padding: 20px;
}

.el-dialog-custom /deep/ .el-dialog__footer {
    border-top: 1px solid #E9E9E9;
}

.el-dialog-custom /deep/ .el-table .cell {
    font-size: 16px;
}

.el-dialog-custom-add {
    overflow: hidden !important;
}

.el-dialog-custom-add /deep/ .el-dialog__body {
    height: 69vh;
    overflow: auto;
    padding: 20px;
}

.el-dialog-custom-add /deep/ .el-dialog__footer {
    border-top: 1px solid #E9E9E9;
}

.el-dialog-custom-add /deep/ .el-table .cell {
    font-size: 16px;
}

.el-dialog-custom-add /deep/ .table-price-td {
    padding: 0;
}

.el-dialog-custom-add /deep/ .table-price-input input {
    text-align: center;
    font-size: 16px;
}

.el-dialog-custom-add /deep/ .table-price-input .table-td-is-error {
    border-color: #F56C6C !important;
}

.el-dialog-custom-add /deep/ .el-textarea__inner {
    font-family: inherit;
}
</style>
